import editor from "./editor";
import commonHelpers from "common/plugins/issues/topic_exists_and_role_matches";
import reasonViewer from "./reason_viewer";

export default {
  ...commonHelpers,
  editor,
  ...reasonViewer,
};
